module.exports = __webpack_public_path__ + "static/img/default_search.635657e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_search.jpg
// module id = fvz7
// module chunks = 27